import { Container, Graphics } from 'pixi.js';

import { GameManager } from '../game/GameManager';

import { ESceneState } from './ESceneState';
import { IScene } from './IScene';
import { SceneName } from './SceneName';

export class DefaultLoadingScene extends Container implements IScene {
  public static readonly sceneID: string = SceneName.DefaultLoadingScene;
  public readonly assetBundles: string[] = [];

  public sceneState: ESceneState = ESceneState.NONE;

  private _loaderBar: Container;
  private _loaderBarBorder: Graphics;
  private _loaderBarFill: Graphics;

  public constructor() {
    super();

    const loaderBarWidth = GameManager.screenWidth * 0.8;

    this._loaderBarFill = new Graphics();
    this._loaderBarFill.setFillStyle({ color: 0x008800, alpha: 1 });
    this._loaderBarFill.rect(0, 0, loaderBarWidth, 50);
    this._loaderBarFill.scale.x = 0;

    this._loaderBarBorder = new Graphics();
    this._loaderBarBorder.setStrokeStyle({ width: 10, color: 0x0, alpha: 1 });
    this._loaderBarBorder.rect(0, 0, loaderBarWidth, 50);

    this._loaderBar = new Container();
    this._loaderBar.addChild(this._loaderBarFill);
    this._loaderBar.addChild(this._loaderBarBorder);
    this._loaderBar.position.x = (GameManager.screenWidth - this._loaderBar.width) / 2;
    this._loaderBar.position.y = (GameManager.screenHeight - this._loaderBar.height) / 2;
    this.addChild(this._loaderBar);
  }

  public update(_delta: number): void {
    // Not Implemented
  }

  public resize(_screenWidth: number, _screenHeight: number): void {
    // Not Implemented
  }

  public downloadProgress(progressRatio: number): void {
    this._loaderBarFill.scale.x = progressRatio;
  }
}
